__turbopack_context__.v({
  "bottom": "twoColumnTextImageDesktop-module-scss-module__eh3uhq__bottom",
  "center": "twoColumnTextImageDesktop-module-scss-module__eh3uhq__center",
  "content": "twoColumnTextImageDesktop-module-scss-module__eh3uhq__content",
  "contentPaddingLeft": "twoColumnTextImageDesktop-module-scss-module__eh3uhq__contentPaddingLeft",
  "contentPaddingRight": "twoColumnTextImageDesktop-module-scss-module__eh3uhq__contentPaddingRight",
  "ctaContainer": "twoColumnTextImageDesktop-module-scss-module__eh3uhq__ctaContainer",
  "darkBlue": "twoColumnTextImageDesktop-module-scss-module__eh3uhq__darkBlue",
  "description": "twoColumnTextImageDesktop-module-scss-module__eh3uhq__description",
  "desktopLayout": "twoColumnTextImageDesktop-module-scss-module__eh3uhq__desktopLayout",
  "horizontal": "twoColumnTextImageDesktop-module-scss-module__eh3uhq__horizontal",
  "image": "twoColumnTextImageDesktop-module-scss-module__eh3uhq__image",
  "left": "twoColumnTextImageDesktop-module-scss-module__eh3uhq__left",
  "middle": "twoColumnTextImageDesktop-module-scss-module__eh3uhq__middle",
  "mobileLayout": "twoColumnTextImageDesktop-module-scss-module__eh3uhq__mobileLayout",
  "right": "twoColumnTextImageDesktop-module-scss-module__eh3uhq__right",
  "roundedImage": "twoColumnTextImageDesktop-module-scss-module__eh3uhq__roundedImage",
  "secondary": "twoColumnTextImageDesktop-module-scss-module__eh3uhq__secondary",
  "subHeader": "twoColumnTextImageDesktop-module-scss-module__eh3uhq__subHeader",
  "textArea": "twoColumnTextImageDesktop-module-scss-module__eh3uhq__textArea",
  "title": "twoColumnTextImageDesktop-module-scss-module__eh3uhq__title",
  "top": "twoColumnTextImageDesktop-module-scss-module__eh3uhq__top",
  "twoColumnTextImageDesktopGrid": "twoColumnTextImageDesktop-module-scss-module__eh3uhq__twoColumnTextImageDesktopGrid",
  "vertical": "twoColumnTextImageDesktop-module-scss-module__eh3uhq__vertical",
});
